/**
 * Datachain Console Internal API
 * API for Datachain application, version : 9.1.6 (build 21776) [27-08-2026 15:10:20]
 *
 * The version of the OpenAPI document: 9.1.6
 * Contact: camille.dubois@adobisgroup.fr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TemporalIntervalModel } from './temporalInterval.model';


/**
 * Dc instance.
 */
export interface ProductInstanceModel { 
    /**
     * object identifier
     */
    id?: number;
    /**
     * created At
     */
    createdAt?: string;
    createdSince?: TemporalIntervalModel;
    /**
     * created By
     */
    createdBy?: string;
    /**
     * updated At
     */
    updatedAt?: string;
    updatedSince?: TemporalIntervalModel;
    /**
     * updated By
     */
    updatedBy?: string;
    /**
     * deleted date
     */
    deletedDate?: string;
    /**
     * label
     */
    label: string;
    /**
     * Identifiant unique, affecté à la création
     */
    uniqueIdentifier: string;
    /**
     * url publique
     */
    publicUrl: string;
    /**
     * url pour la communication inter-module
     */
    internalUrl: string;
    /**
     * type de module
     */
    type: ProductInstanceModel.TypeEnum;
    /**
     * Version instance
     */
    productVersion?: string;
    /**
     * Last time we received product instance version
     */
    lastSeen?: string;
    /**
     * module description
     */
    description?: string;
    /**
     * nb users having role on this instance
     */
    nbUsers?: number;
    /**
     * nb groups having role on this instance
     */
    nbGroups?: number;
    /**
     * nb product instances linked to this instance as a client
     */
    nbInstancesIsClient?: number;
    /**
     * nb product instances linked to this instance as a server
     */
    nbInstancesIsServer?: number;
}
export namespace ProductInstanceModel {
    export type TypeEnum = 'DC_CORE' | 'DC_MAESTRO' | 'DC_MARKETPLACE' | 'PYDC' | 'DC_CONSOLE' | 'EXTERNAL_APP';
    export const TypeEnum = {
        DcCore: 'DC_CORE' as TypeEnum,
        DcMaestro: 'DC_MAESTRO' as TypeEnum,
        DcMarketplace: 'DC_MARKETPLACE' as TypeEnum,
        Pydc: 'PYDC' as TypeEnum,
        DcConsole: 'DC_CONSOLE' as TypeEnum,
        ExternalApp: 'EXTERNAL_APP' as TypeEnum
    };
}


